$(document).ready(function() {

    var windowWidth = $(window).width();

    // MENU START
    $('.js-menu-btn').click(function(){
        let headerHeight = $('header').outerHeight();
        $('.menu').css('height', 'calc(100vh - '+ headerHeight+'px)');
        $(this).toggleClass('open');
        $('nav').fadeToggle();
        $('nav > ul').addClass('scrollable');
        $('body').toggleClass("menu-open");
    });

    $('body').on('click', '.js-open-sub > a', function(e){
        if (windowWidth < 1200) {
            e.preventDefault();
            var current_ul = $(this).parent().children('ul:first');
            current_ul.addClass('scrollable');
            $('ul').not(current_ul).removeClass('scrollable');
            $(this).parent().addClass("open").siblings().removeClass("open");
        }
    });

    $('body').on('click', '.js-close-sub', function(e){
        if (windowWidth < 1200) {
            e.preventDefault();
            e.stopPropagation();
            $(this).closest('.submenu').parent().removeClass('open');
            $('nav ul').removeClass('scrollable');
            $(this).closest('ul').parent().closest('ul').addClass('scrollable').scrollTop(0); //current open
        }
    });
    // MENU END



    //breadcrump back
    $('.js-backlink a').click(function(e){
        e.preventDefault();
        history.go(-1);
    });

    // contrast switch
    function createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    $('.js-contrast-switch').click(function(e){
        e.preventDefault();
        if (readCookie("contrast")) {
            eraseCookie("contrast");
        } else {
            createCookie("contrast", 1);
        }
        window.location.reload();
    });

    // Mask Accordions behaviour for desktop ( lg up)
    if (windowWidth > 991) {
        // DCE Subject Accordion - Change Positioning to two Columns
        $('.mask-subjects .subject-content.ct-mobile').each(function() {
            var temp = $(this).html();
            $(this).remove()
            $(temp).appendTo($('.mask-subjects .subject-content.ct-desktop'));
        });

        // DCE Philosophy Accordion - Destroy Accordion
        $('#mask-philosophy-accordion .ph-tt-inner').attr('data-bs-toggle' , 'false');
        $('#mask-philosophy-accordion .ph-tt-inner').attr('aria-expanded','true')
        $('#mask-philosophy-accordion .ph-ct-inner').addClass('show');
    }

    // Footer behaviour for desktop (xl up) - Positioned absolute to bottom for pages with less content
    if (windowWidth > 1199) {
        var footerHeight = $('footer').outerHeight();
        $('main').css('padding-bottom', footerHeight + 'px');
    }


    $('.js-scroll-top').click(function(){
         $("html, body").animate({scrollTop: 0}, 800);
    });

    // Init Magnific Popup
    $('.js-magnific-popup-lightbox').magnificPopup({type:'image'});

    // Info-Popup: im Backend als "geöffnet" markierte Popups beim ersten Laden ausklappen,
    // bis der Besucher es selbst zuklappt (Cookie "hide-div").
    if ($('#infoPopup').attr("data-open") == 'show' && !readCookie("hide-div")) {
        $('#infoPopup').addClass('show');
        $('#showpopup').attr('aria-expanded', 'true');
    }

    if (readCookie("hide-div")) {
        $('#infoPopup').removeClass('show');
        $('#showpopup').attr('aria-expanded', 'false');
    }

    $('#showpopup').click(function () {
        createCookie('hide-div', true, 365);
    });

});
